export const resolveContactAvatar = (contact) => {
  try {
    const url = contact?.urlPicture || contact?.profilePicUrl || "";
    if (typeof url === "string" && url.trim() !== "") {
      return url;
    }
  } catch (e) {
    // noop
  }
  return "/nopicture.png";
};

export const hasCustomAvatar = (contact) => {
  const url = resolveContactAvatar(contact);
  if (!url) return false;
  return !(url.includes("nopicture.png") || url.endsWith("/nopicture.png"));
};

export const resolveTicketContactAvatar = (ticket) => {
  return resolveContactAvatar(ticket?.contact);
};

